module.exports = __webpack_public_path__ + "static/media/infoJumbo2.9114a264.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ziersch/images/infoJumbo2.png
// module id = 471
// module chunks = 0